import React from "react";
import content from '../../../../content/main.archie';
import Markdown from 'react-remarkable';
import {LeftArrow,RightArrow} from '../../Arrow/Arrow.jsx';
import {contentToText} from '../../../utils/helpers.jsx';
import Inset from '../../Inset/Inset.jsx';
let tablesvg = `<g>
    <g>
      <g>
        <path class="person person0" d="M36.57,7c-2.84,4.64-2.09,10.85.71,15.11,3.27,4.55,8.34,6.3,13.64,5.83a14.23,14.23,0,0,0,11.13-8.2c2.18-4.93,1.23-11.42-2.75-15.26A14.26,14.26,0,0,0,43.77.93C40.73,1.73,38.22,4.39,36.57,7Z"/>
        <path class="person person0" d="M80.06,70.83c0,4.79-3.44,8.67-7.69,8.67H25.6c-4.25,0-7.69-3.88-7.69-8.67V38.31c0-4.79,3.44-8.67,7.69-8.67H72.37c4.25,0,7.69,3.88,7.69,8.67V70.83Z"/>
        <text x="49" y="45" class="faction inset-text">
            <tspan x="49" dy="-0.5em">Flags of</tspan>
            <tspan x="49" dy="1.05em">convenience</tspan>
        </text>
      </g>
      <g>
        <path class="person person1" d="M107.46,14.1a13.89,13.89,0,0,0,3.51,9,14.6,14.6,0,0,0,15.49,4.17,14.55,14.55,0,0,0,9.1-9.76A14.08,14.08,0,0,0,132,4.43a14.22,14.22,0,0,0-24,6C107.65,11.87,107.75,12.77,107.46,14.1Z"/>
        <path class="person person1" d="M152.79,70.83c0,4.79-3.44,8.67-7.69,8.67H98.33c-4.25,0-7.69-3.88-7.69-8.67V38.31c0-4.79,3.44-8.67,7.69-8.67H145.1c4.25,0,7.69,3.88,7.69,8.67V70.83Z"/>
        <text x="122" y="45" class="faction inset-text">Industry</text>
      </g>
      <g>
        <path class="person person2" d="M181.59,8.08a14.27,14.27,0,0,0,2.27,15.21,14.42,14.42,0,0,0,14.92,4.12c4.26-1.18,8.48-5.4,9.29-9.81A13.83,13.83,0,0,0,203.44,3.3a14.85,14.85,0,0,0-15-1.94A15.36,15.36,0,0,0,181.59,8.08Z"/>
        <path class="person person2" d="M225.52,70.83c0,4.79-3.44,8.67-7.69,8.67H171.06c-4.25,0-7.69-3.88-7.69-8.67V38.31c0-4.79,3.44-8.67,7.69-8.67h46.78c4.25,0,7.69,3.88,7.69,8.67V70.83Z"/>
        <text x="195" y="45" class="faction inset-text">NGOs</text>
      </g>
    </g>
    <g>
      <g>
        <path class="person person3" d="M43.77,208.67a14.26,14.26,0,0,0,15.54-3.6c4-3.84,4.93-10.33,2.75-15.26a14.23,14.23,0,0,0-11.13-8.2c-5.31-.47-10.38,1.28-13.64,5.83-2.8,4.26-3.55,10.47-.71,15.11C38.22,205.22,40.73,207.87,43.77,208.67Z"/>
        <path class="person person3" d="M80.06,138.77c0-4.79-3.44-8.67-7.69-8.67H25.6c-4.25,0-7.69,3.88-7.69,8.67v32.52c0,4.79,3.44,8.67,7.69,8.67H72.37c4.25,0,7.69-3.88,7.69-8.67V138.77Z"/>
        <text x="49" y="166" class="faction inset-text">U.S.</text>
      </g>
      <g>
        <path class="person person4" d="M108,199.15a14.22,14.22,0,0,0,24,6,14.08,14.08,0,0,0,3.55-13.08A14.27,14.27,0,0,0,111,186.5a13.89,13.89,0,0,0-3.51,9C107.75,196.83,107.65,197.73,108,199.15Z"/>
        <path class="person person4" d="M152.79,138.77c0-4.79-3.44-8.67-7.69-8.67H98.33c-4.25,0-7.69,3.88-7.69,8.67v32.52c0,4.79,3.44,8.67,7.69,8.67H145.1c4.25,0,7.69-3.88,7.69-8.67V138.77Z"/>
        <text x="122" y="166" class="faction inset-text">E.U.</text>
      </g>
      <g>
        <path class="person person5" d="M188.42,208.25a14.85,14.85,0,0,0,15-1.94A13.83,13.83,0,0,0,208.08,192c-0.81-4.41-5-8.62-9.29-9.81a14.42,14.42,0,0,0-14.92,4.12,14.27,14.27,0,0,0-2.27,15.21A15.36,15.36,0,0,0,188.42,208.25Z"/>
        <path class="person person5" d="M225.52,138.77c0-4.79-3.44-8.67-7.69-8.67H171.06c-4.25,0-7.69,3.88-7.69,8.67v32.52c0,4.79,3.44,8.67,7.69,8.67h46.78c4.25,0,7.69-3.88,7.69-8.67V138.77Z"/>
        <text x="195" y="166" class="faction inset-text">BRICS</text>
      </g>
    </g>
  </g>
  <g>
    <path class="table-outer" d="M193.48,153.39c-1.43,0-2.9,0-4.37-.15L44,153.1H43.8C24.93,151.62,7.33,137,1.94,118.37-4.39,96,5.09,73.28,25.52,62a47.83,47.83,0,0,1,21.21-5.72H194.49l1.37,0c18.46,0,36.49,12.15,43.84,29.54,7.4,17.58,3.48,39.08-9.55,52.3-9.65,10.17-22,15.34-36.66,15.34h0Z"/>
    <path class="table-inner" d="M4,117.77C9,135.16,25.77,149.51,44,150.93l145.22,0.14c15.59,1,28.9-3.46,39.42-14.55,12.65-12.84,16.06-33.4,9.1-49.94C230.59,69.77,213,57.79,194.49,58.4H46.81a45.47,45.47,0,0,0-20.23,5.45C7.44,74.46-2.09,96.12,4,117.77Z"/>
  </g>
  <image width="491" height="162" transform="translate(64.4 85) scale(0.24)" xlink:href="images/IMO-logo-orange.png"/>`


const TableVector = (props) => <svg className={"imotable "+(props.selected>=0?"selected"+props.selected:"")} viewBox="0 0 243.4 209.6" width="100%" dangerouslySetInnerHTML={{__html: tablesvg}} onClick={props.onClick}/>;

const ButtonWidget = (props) => {
    return <div style={{whiteSpace:"nowrap"}}>
        <LeftArrow onClick={() => {if(props.onChange) { props.onChange(-1); }} } disabled={props.selected==0}/>
        <span className="slidecounter">{(props.selected+1)+" of "+props.total}</span>
        <RightArrow onClick={() => {if(props.onChange) { props.onChange(1); }} } disabled={props.selected==props.total-1}/> 
    </div>
}

export default class IMOStory extends React.Component {
    constructor() {
        super(...arguments);
        this.state= {selected:0};
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    handleChange(change) {
        this.setState({selected: Math.max(Math.min(this.state.selected+change,5),0)});
    }
    getCard(num) {
        return <div className="card-panel">
            <div style={{display:"table",width:"100%"}}>
                <div style={{display:"table-cell"}}> 
                    <div className="cardtitle">{content['imocards'][num].title}</div>
                    <div className="cardsubtitle">{content['imocards'][num].subtitle}</div>
                </div>
                <div style={{display:"table-cell",verticalAlign:"top",paddingLeft:"10px"}}>
                    <div style={{textAlign:"right"}}>
                        <ButtonWidget selected={num} total={6} onChange={this.handleChange}/>
                    </div>
                </div>
            </div>
            <Markdown>
                {contentToText(content['imocards'][num].content,{})}
            </Markdown>
        </div>
        
    }
    handleClick(obj) {
        //this.setState({selected: Math.max(Math.min(this.state.selected+change,5),0)});
        if(obj.target && obj.target.className && obj.target.className.baseVal && obj.target.className.baseVal.indexOf("person")>=0) {
            let re = /person(\d+)/g;
            let matches=re.exec(obj.target.className.baseVal);
            if(matches.length>1) {
                let personid = parseInt(matches[1]);
                this.setState({selected: personid});
            }
        }
        
    }
    render() {
        return <div ref="imostory" className="imostory container inset-text">
            <Inset hed="Power Players" dek="What are some of the factions that influence the IMO's decisions?" source="Source: Asia Weekly research">
                <div className="section">
                    <div className="row">
                        <div className="col l6 m4 s12"> 
                            <div style={{maxWidth:"485px"}}>
                                <TableVector selected={this.state.selected} onClick={this.handleClick}/>
                            </div>
                        </div>
                        <div className="col l6 m8 s12">
                            {this.getCard(this.state.selected)}
                        </div>
                    </div>
                </div>
            </Inset>
        </div>
    }
}




// WEBPACK FOOTER //
// ./src/js/components/special/IMOStory/IMOStory.jsx